import { Link } from 'react-router';

import { Card } from '../../shared/ui/primitives';
import { Logo } from '../../shared/ui/Logo';
import { SoftwareList } from './SoftwareList';

/** Публичная страница со ссылками на программу для просмотра снимков —
 *  для получателей писем без аккаунта. */
export function DownloadsPage() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-10">
      <div className="w-full max-w-md space-y-6">
        <div className="flex justify-center">
          <Link to="/">
            <Logo size="lg" className="flex-col gap-2" />
          </Link>
        </div>
        <Card className="space-y-4 p-6">
          <div className="space-y-1">
            <h1 className="text-lg font-semibold text-ink">Программа для просмотра снимков</h1>
            <p className="text-sm text-muted">
              Установите Romexis, чтобы открыть скачанные снимки КЛКТ и другие DICOM-файлы.
            </p>
          </div>
          <SoftwareList />
        </Card>
      </div>
    </div>
  );
}
